const accessMaster = {

    COUNTRY_LIST: { name: 'Country', path: '/country-list' },
    ADD_COUNTRY: { name: 'Add Country', path: '/create-country' },
    UPDATE_COUNTRY: { name: 'Update Country', path: '/edit-country' },
    DELETE_COUNTRY: { name: 'Delete Country', path: '/delete-country' },

    STATE_LIST: { name: 'State', path: '/state-list' },
    ADD_STATE: { name: 'Add State', path: '/create-state' },
    UPDATE_STATE: { name: 'Update State', path: '/edit-state' },
    DELETE_STATE: { name: 'Delete State', path: '/delete-state' },

    DISTRICT_LIST: { name: 'District', path: '/district-list' },
    ADD_DISTRICT: { name: 'Add District', path: '/create-district' },
    UPDATE_DISTRICT: { name: 'Update District', path: '/edit-district' },
    DELETE_DISTRICT: { name: 'Delete District', path: '/delete-district' },

    TEHSIL_LIST: { name: 'Tehsil', path: '/tehsil-list' },
    ADD_TEHSIL: { name: 'Add Tehsil', path: '/create-tehsil' },
    UPDATE_TEHSIL: { name: 'Update Tehsil', path: '/edit-tehsil' },
    DELETE_TEHSIL: { name: 'Delete Tehsil', path: '/delete-tehsil' },

    CITY_LIST: { name: 'City', path: '/city-list' },
    ADD_CITY: { name: 'Add City', path: '/create-city' },
    UPDATE_CITY: { name: 'Update City', path: '/edit-city' },
    DELETE_CITY: { name: 'Delete City', path: '/delete-city' },

    CATEGORY_LIST: { name: 'Category', path: '/category-list' },
    ADD_CATEGORY: { name: 'Add Category', path: '/create-category' },
    UPDATE_CATEGORY: { name: 'Update Category', path: '/edit-category' },
    DELETE_CATEGORY: { name: 'Delete Category', path: '/delete-category' },

    SUB_CATEGORY_LIST: { name: 'Sub Category', path: '/sub-category-list' },
    ADD_SUB_CATEGORY: { name: 'Add Sub Category', path: '/create-sub-category' },
    UPDATE_SUB_CATEGORY: { name: 'Update Sub Category', path: '/edit-sub-category' },
    DELETE_SUB_CATEGORY: { name: 'Delete Sub Category', path: '/delete-sub-category' },

    SERVICE_LIST: { name: 'Service', path: '/service-list' },
    ADD_SERVICE: { name: 'Add Service', path: '/create-service' },
    UPDATE_SERVICE: { name: 'Update Service', path: '/edit-service' },
    DELETE_SERVICE: { name: 'Delete Service', path: '/delete-service' },

    PLAN_LIST: { name: 'Plan', path: '/plan-list' },
    ADD_PLAN: { name: 'Add Plan', path: '/create-plan' },
    UPDATE_PLAN: { name: 'Update Plan', path: '/edit-plan' },
    DELETE_PLAN: { name: 'Delete Plan', path: '/delete-plan' },

    DESIGNATION_LIST: { name: 'Designation', path: '/designation-list' },
    ADD_DESIGNATION: { name: 'Add Designation', path: '/create-designation' },
    UPDATE_DESIGNATION: { name: 'Update Designation', path: '/edit-designation' },
    DELETE_DESIGNATION: { name: 'Delete Designation', path: '/delete-designation' },

    EXPENSE_CATEGORY_LIST: { name: 'Expenses Category', path: '/expenses-category-list' },
    ADD_EXPENSE_CATEGORY: { name: 'Add Expenses Category', path: '/add-expenses-category' },
    UPDATE_EXPENSE_CATEGORY: { name: 'Update Expenses Category', path: '/update-expenses-category' },
    DELETE_EXPENSE_CATEGORY: { name: 'Delete Expenses Category', path: '/delete-expenses-category' },

}

export default accessMaster;